import * as Sentry from '@sentry/browser';

/*******************************************************************************
 * sentryExceptionHandlerFactory */
/**
 * Returns the Angular exception handler. It logs the exception and, when Sentry
 * is enabled, reports it with its cause and any component report state.
 *
 * @param  exception  The exception that was thrown.
 * @param  cause  Cause of the exception, if known.
 *******************************************************************************/
/* @ngInject */ export function sentryExceptionHandlerFactory($log) {
  return function (exception, cause) {
    if (cause) {
      $log.error(exception, cause);
    } else {
      $log.error(exception);
    }

    // No-op in dev builds — SENTRY_DSN is an empty string injected by DefinePlugin
    if (!SENTRY_DSN) return;

    Sentry.withScope((scope) => {
      // setContext requires an object; cause is often a string (e.g. from promise
      // rejections), so wrap primitives to avoid losing the data.
      if (cause) {
        scope.setContext(
          'cause',
          typeof cause === 'object' ? cause : { message: cause }
        );
      }
      // PointOfSale attaches component state to exceptions via sentryComponentReporter.
      // Forwarding it here ensures that context reaches Sentry without PointOfSale
      // needing its own Sentry dependency.
      if (exception.reportState) {
        scope.setContext('Component State', exception.reportState);
      }
      Sentry.captureException(exception);
    });
  };
}
